import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import Previred from "../../../../pages/Profile/Documentation/Previred";
import { DocumentsPagesContainerProps } from "../../../../interfaces/containers";

function mapStateToProps(state: DocumentsPagesContainerProps) {
    return{
        
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Previred);